import { render, staticRenderFns } from "./GrantsConstraintsPlanInfo.vue?vue&type=template&id=3ff03976&"
import script from "./GrantsConstraintsPlanInfo.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlanInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports